module.exports = __webpack_public_path__ + "img/icon_cursor-right_blue.55b6f62f.svg";